import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyle = makeStyles({
	label: {
		cursor: "pointer",
		...shorthands.padding("2px", "5px", 0, "5px"),
	},
	disabled: {
		opacity: 0.5,
		cursor: "not-allowed",
	},
	input: {
		display: "none",
	},
});
